import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import BlogCards from './BlogCards'

const Component = () => {
  return (
    <StaticQuery
    query={query}
    render={({ posts, collection }) => {
      posts = posts.nodes.map(post => ({
        title: post.title,
        url: `https://medium.com/${collection.slug}/${post.uniqueSlug}`,
        image: `https://cdn-images-1.medium.com/max/314/${post.virtuals.previewImage.imageId}`, 
        date: post.firstPublishedAt,
        readTime: Math.ceil(post.virtuals.readingTime),
        author: {
          name: post.author.name,
          image: `https://cdn-images-1.medium.com/fit/c/36/36/${post.author.imageId}`
        }
      }))

      return (
        <BlogCards posts={posts}/>
      )
    }} />
  )  
}
export default Component

const query = graphql`
query {
  posts: allMediumPost(sort: {fields: firstPublishedAt, order: DESC}, limit: 4) {
    nodes {
      title
      uniqueSlug
      virtuals {
        readingTime
        previewImage {
          imageId
        }
      }
      firstPublishedAt
      author {
        name
        imageId
      }
    }
  }
  collection: mediumCollection {
    slug
  }
}
`